import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META, { type TeamInviteCtaClickedLocation } from './useTrackTeamInviteCtaClicked.meta';

export type { TeamInviteCtaClickedLocation } from './useTrackTeamInviteCtaClicked.meta';

export type UseTrackTeamInviteCtaClickedParams = {
  location: TeamInviteCtaClickedLocation;
};

export const useTrackTeamInviteCtaClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackTeamInviteCtaClicked = useCallback(
    (params: UseTrackTeamInviteCtaClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackTeamInviteCtaClicked };
};
